import {
  type ConditionViolationsStatus,
  ConditionViolationType,
} from '@/warranty/domain/entities/condition-violation-status';

export const dummyConditionViolationTimeseriesData = [
  {
    id: 'VIO1',
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B01',
    unitFullId: 'Smart_Hill/B01/Rack_10',
    fullFrontendId: 'Smart_Hill/B01/Rack_10',
    description: ConditionViolationType.TEMPERATURE_SPIKE,
    siteId: '34567',
    timeseries: Array.from({ length: 30 }, (_, i) => ({
      timestamp: new Date(2025, 3, i + 1), // April 1-30, 2025
      count: Math.floor(Math.random() * 2), // 0 or 1
    })),
  },
  {
    id: 'VIO2',
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B02',
    unitFullId: 'Smart_Hill/B02/Rack_10',
    fullFrontendId: 'Smart_Hill/B02/Rack_10',
    description: ConditionViolationType.HIGH_AVG_SOC,
    siteId: '34568',
    timeseries: Array.from({ length: 30 }, (_, i) => ({
      timestamp: new Date(2025, 3, i + 1), // April 1-30, 2025
      count: Math.floor(Math.random() * 2), // 0 or 1
    })),
  },
  {
    id: 'VIO3',
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B19',
    unitFullId: 'Smart_Hill/B19/Rack_05',
    fullFrontendId: 'Smart_Hill/B19/Rack_05',
    description: ConditionViolationType.LARGE_DOD,
    siteId: '34569',
    timeseries: Array.from({ length: 30 }, (_, i) => ({
      timestamp: new Date(2025, 3, i + 1), // April 1-30, 2025
      count: Math.floor(Math.random() * 2), // 0 or 1
    })),
  },
  {
    id: 'VIO4',
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B05',
    unitFullId: 'Smart_Hill/B05/Rack_03',
    fullFrontendId: 'Smart_Hill/B05/Rack_03',
    description: ConditionViolationType.HIGH_AVG_SOC,
    siteId: '34570',
    timeseries: Array.from({ length: 30 }, (_, i) => ({
      timestamp: new Date(2025, 3, i + 1), // April 1-30, 2025
      count: Math.floor(Math.random() * 2), // 0 or 1
    })),
  },
];

export const dummyConditionViolationStatus: ConditionViolationsStatus[] = [
  {
    id: 'VIO1',
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B01',
    unitFullId: 'Smart_Hill/B01/Rack_10',
    fullFrontendId: 'Smart_Hill/B01/Rack_10',
    description: ConditionViolationType.TEMPERATURE_SPIKE,
    extremeValue: 42,
    unit: '°C',
    latestDetect: new Date('2025-04-22'),
    duration: 0.31,
    affectedUnits: 1,
  },
  {
    id: 'VIO2',
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B01',
    unitFullId: 'Smart_Hill/B01/Rack_10',
    fullFrontendId: 'Smart_Hill/B01/Rack_10',
    description: ConditionViolationType.HIGH_VOLTAGE,
    extremeValue: 3.8,
    unit: 'V',
    latestDetect: new Date('2025-04-22'),
    duration: 4,
    affectedUnits: 6,
  },
  {
    id: 'VIO3',
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B02',
    unitFullId: 'Smart_Hill/B02/Rack_04',
    fullFrontendId: 'Smart_Hill/B02/Rack_04',
    description: ConditionViolationType.HIGH_VOLTAGE,
    extremeValue: 3.71,
    unit: 'V',
    latestDetect: new Date('2025-04-23'),
    duration: 1,
    affectedUnits: 1,
  },
  {
    id: 'VIO4',
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B19',
    unitFullId: 'Smart_Hill/B19/Rack_05',
    fullFrontendId: 'Smart_Hill/B19/Rack_05',
    description: ConditionViolationType.TEMPERATURE_SPIKE,
    extremeValue: 48,
    unit: '°C',
    latestDetect: new Date('2025-04-21'),
    duration: 0.31,
    affectedUnits: 1,
  },
  {
    id: 'VIO5',
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B19',
    unitFullId: 'Smart_Hill/B19/Rack_05',
    fullFrontendId: 'Smart_Hill/B19/Rack_05',
    description: ConditionViolationType.HIGH_VOLTAGE,
    extremeValue: 3.71,
    unit: 'V',
    latestDetect: new Date('2025-04-21'),
    duration: 0.31,
    affectedUnits: 1,
  },
  {
    id: 'VIO6',
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B05',
    unitFullId: 'Smart_Hill/B05/Rack_03',
    fullFrontendId: 'Smart_Hill/B05/Rack_03',
    description: ConditionViolationType.HIGH_AVG_SOC,
    extremeValue: 88,
    unit: '%',
    latestDetect: new Date('2025-12-31'),
    duration: 5, // TODO: how to account for the future warning here?
    affectedUnits: 4,
  },
];
